import { createStructuredSelector } from 'reselect'

import {
  ASSESSMENT_TYPE_LIST,
  ASSESSMENT_TYPE_LIST_SUCCESS, 
  ASSESSMENT_TYPE_LIST_ERROR,
  ASSESSMENT_TYPE_PAGE_SET,
  ASSESSMENT_TYPE_SEARCH_SET,
  ASSESSMENT_TYPE_SEARCH_CHANGE,
  ASSESSMENT_TYPE_ADD_SET,
  ASSESSMENT_TYPE_ADD_MODAL_SET,
  ASSESSMENT_TYPE_ADD,
  ASSESSMENT_TYPE_ADD_SUCCESS,
  ASSESSMENT_TYPE_ADD_ERROR,
  ASSESSMENT_TYPE_ADD_CHANGE,
  ASSESSMENT_TYPE_DETAIL,
  ASSESSMENT_TYPE_DETAIL_SUCCESS,
  ASSESSMENT_TYPE_DETAIL_ERROR,
  ASSESSMENT_TYPE_VIEW_MODAL_SET,
  ASSESSMENT_TYPE_EDIT_CHANGE,
  ASSESSMENT_TYPE_EDIT_MODAL_SET,
  ASSESSMENT_TYPE_UPDATE,
  ASSESSMENT_TYPE_UPDATE_SUCCESS,
  ASSESSMENT_TYPE_UPDATE_ERROR,
  ASSESSMENT_TYPE_VIEW_TAB_SET,
} from '../../actions';

export const NAME = 'assessment_type';

export const AssessmentTypeList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: ASSESSMENT_TYPE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AssessmentTypeListSuccess = (data) => ({
  type: ASSESSMENT_TYPE_LIST_SUCCESS,
  payload: data
});

export const AssessmentTypeListError = (error) => ({
  type: ASSESSMENT_TYPE_LIST_ERROR,
  payload: error
});

export const AssessmentTypePageSet = (data) => ({
  type: ASSESSMENT_TYPE_PAGE_SET,
  payload: data
});

export const AssessmentTypeSearchSet = (data) => ({
  type: ASSESSMENT_TYPE_SEARCH_SET,
  payload: data
});

export const AssessmentTypeSearchChangeSet = (data) => ({
  type: ASSESSMENT_TYPE_SEARCH_CHANGE,
  payload: data
});

export const AssessmentTypeAddChangeSet = (data) => ({
  type: ASSESSMENT_TYPE_ADD_CHANGE,
  payload: data
});

export const AssessmentTypeAddSet = (data) => ({
  type: ASSESSMENT_TYPE_ADD_SET,
  payload: data
});

export const AssessmentTypeAddModalSet = (data) => ({
  type: ASSESSMENT_TYPE_ADD_MODAL_SET,
  payload: data
});

export const AssessmentTypeAdd = (data) => ({
  type: ASSESSMENT_TYPE_ADD,
  payload: data
});

export const AssessmentTypeAddSuccess = (message) => ({
  type: ASSESSMENT_TYPE_ADD_SUCCESS,
  payload: message
});

export const AssessmentTypeAddError = (error) => ({
  type: ASSESSMENT_TYPE_ADD_ERROR,
  payload: error
});

export const AssessmentTypeDetail = (data) => ({
  type: ASSESSMENT_TYPE_DETAIL,
  payload: data
});

export const AssessmentTypeDetailSuccess = (data) => ({
  type: ASSESSMENT_TYPE_DETAIL_SUCCESS,
  payload: data
});

export const AssessmentTypeDetailError = (error) => ({
  type: ASSESSMENT_TYPE_DETAIL_ERROR,
  payload: error
});

export const AssessmentTypeViewModalSet = (data) => ({
  type: ASSESSMENT_TYPE_VIEW_MODAL_SET,
  payload: data
});

export const AssessmentTypeEditModalSet = (data) => ({
  type: ASSESSMENT_TYPE_EDIT_MODAL_SET,
  payload: data
});

export const AssessmentTypeEditChangeSet = (data) => ({
  type: ASSESSMENT_TYPE_EDIT_CHANGE,
  payload: data
});

export const AssessmentTypeUpdate = (data) => ({
  type: ASSESSMENT_TYPE_UPDATE,
  payload: data
});

export const AssessmentTypeUpdateSuccess = (message) => ({
  type: ASSESSMENT_TYPE_UPDATE_SUCCESS,
  payload: message.message
});

export const AssessmentTypeUpdateError = (error) => ({
  type: ASSESSMENT_TYPE_UPDATE_ERROR,
  payload: error
});

export const AssessmentTypeViewTabSet = (data) => ({
  type: ASSESSMENT_TYPE_VIEW_TAB_SET,
  payload: data
});

const assessment_type = (state) => state[NAME];

export const AssessmentTypeSelector = createStructuredSelector({
  assessment_type
})
 